import React, { Component } from "react";
import { browserHistory } from "react-router";
import { connect } from "react-redux";

import {

  setUiFlag,
  actionAddArray2Redux,
  actionAddSingleRecord,
  setupUsers,
  loadFbData,
  resetRedux
} from "../../../../store/actions";
import { compose } from "recompose";
import { withFirebase } from "../../Firebase";
import {  CircleProgress } from "reactackle";
import "./login.css";
import { localState } from "../../../../staticData/rawState";

class UserLogin extends Component {
  constructor(props) {
    super(props);
    this.loginHandler = this.loginHandler.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePassChange = this.handlePassChange.bind(this);
    this.state = {
      message: "",
      email: "ahmed_fayyaz@outlook.com",
      password: "password1",
      isAuthorized: false,
      notInitialized: true,
      loginProgress: false,
      logview: [],
      localhost: localState.hostname
    };
  }

  componentDidMount() {}

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    ////console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  loginHandler = event => {
    console.log("doing login...");
    event.preventDefault();
    if (
      this.state.notInitialized &&
      !this.props.firebase.auth &&
      this.props.firebase.auth === undefined
    ) {
      this.setState(prevState => {
        return {
          ...prevState,
          logview: [...prevState.logview, "BROOKLYNZ"]
        };
      });
      this.props.firebase.doInitiate("BROOKLYNZ");
      console.log("init done");
      this.setState(prevState => {
        return {
          ...prevState,
          notInitialized: false
        };
      });
    }

    let fbCloudUrl = "https://us-central1-brooklynztest.cloudfunctions.net";
    let fbDbUrl = "https://brooklynztest.firebaseio.com";

    this.setState(prevState => {
      return {
        ...prevState,
        loginProgress: true
      };
    });
    this.props.firebase.auth
      .signInWithEmailAndPassword(
        this.refs.email.value,
        this.refs.password.value
      )
      .then(userRes => {
        //console.log("stringify and parse done/skipped");
        console.log("auth done");
        let res = userRes.user;
        this.props
          .loadFbData("createTable", this.props.firebase)
          .then(crTableRes => {
            console.log("create table done");
            this.props
              .loadFbData("listOfTables", this.props.firebase)
              .then(listRes => {
                console.log("listOtTables done");
                this.props
                  .loadFbData("menuDesigner", this.props.firebase)
                  .then(desRes => {
                    console.log("menus done");
                    this.stateChangeHandler("login done", "logview", false);
                    this.props.onSetUiFlag("showSpinner", false);
                    //console.log("ui flag switched off");

                    this.props.onSetUiFlag("userUid", res.uid);

                    this.props.onSetUiFlag("userEmail", res.email);
                    //console.log("email updated");

                    //console.log("inside load data: " + this.refs.email.value);
                    let currEmail = this.refs.email.value;
                    this.props.firebase.db
                      .ref("/users")
                      .on("value", snapshot => {
                        ////console.log("Linking " + tableName);
                        let tmpArray = [];
                        let fbOject = [];
                        Promise.all([snapshot.val()]).then(res => {
                          fbOject = res[0];
                          //console.log("now recieved the response for teams loading");
                          tmpArray = Object.keys(fbOject).map(key => ({
                            ...fbOject[key],
                            key: key
                          }));
                          tmpArray.reverse();
                          //console.log("array reversed");
                          ////console.log("Total Records: " + tmpArray.length);
                          this.props.onAddArray({
                            path: "users",
                            payload: tmpArray
                          });

                          let currentUser = {};

                          //

                          currentUser = tmpArray.find(userObj => {
                            if (userObj.userEmail === currEmail) {
                              return userObj;
                            }
                          });

                          //console.log("admin status: " + JSON.stringify(currentUser));

                          this.props.addRecord({
                            path: "userProfile",
                            payload: currentUser
                          });

                          if (currentUser !== undefined) {
                            ////console.log("~!@~!@ " + JSON.stringify(currentUser));
                            let isThisAdmin =
                              currentUser.roleName === "ADMIN" ||
                              currentUser.roleName === "SUPERADMIN";
                            let isThisSuperAdmin =
                              currentUser.roleName === "SUPERADMIN";
                            this.props.onSetUiFlag(
                              "currUserRole",
                              currentUser.roleName
                            );
                            this.props.onSetUiFlag("isThisAdmin", isThisAdmin);
                            this.props.onSetUiFlag(
                              "isThisSuperAdmin",
                              isThisSuperAdmin
                            );

                            let allMenus = {};
                            let allMenusFromDb = this.props.menuDesigner;
                            if (allMenusFromDb && allMenusFromDb.length > 0) {
                              let userMenu = allMenusFromDb.find(
                                singMenu =>
                                  singMenu.name === currentUser.roleName
                              );
                              if (userMenu) {
                                allMenus = userMenu.menuItems.map(
                                  singleMenu => {
                                    let srcTable = this.props.listOfTables.find(
                                      item => item.name === singleMenu.tableName
                                    );
                                    if (
                                      srcTable &&
                                      srcTable !== undefined &&
                                      srcTable.name
                                    ) {
                                      return {
                                        ...singleMenu,
                                        menuCaption: srcTable.menu
                                      };
                                    }
                                  }
                                );
                                this.props.onSetUiFlag("userMenus", allMenus);
                              }
                            }

                            this.props.addRecord({
                              path: "currentUser",
                              payload: currentUser
                            });

                            this.props.addRecord({
                              path: "team",
                              payload: {
                                name: "BROOKLYNZ",
                                fbCloudUrl: fbCloudUrl,
                                fbDbUrl: fbDbUrl
                              }
                            });
                            console.log("all done");
                            browserHistory.push("landingPage");
                          }
                        });
                      });
                  });
              });
          });
      })
      .catch(error => {
        console.log("some error");
        console.log(error);
        this.setState(prevState => {
          return {
            ...prevState,
            message: error.message,
            loginProgress: false,
            logview: [...prevState.logview, error]
          };
        });
      });
  };

  loadData = tableName => {};

  handleEmailChange(evt) {
    this.setState({
      email: evt.target.value
    });
  }

  handlePassChange(evt) {
    this.setState({
      password: evt.target.value
    });
  }

  getError = () => {
    if (this.state.message !== "" && this.state.message !== undefined) {
      return <div>{this.state.message}</div>;
    }
  };

  getLoader = () => {
    if (this.state.loginProgress) {
      return (
        <div
          style={{
            textAlign: "center"
          }}
        >
          <CircleProgress
            indeterminate
            subtitle="Connecting..."
            circleSize={40}
            strokeSize={5}
            labelPositionY="bottom"
            labelPositionX="center"
          />
        </div>
      );
    } else {
      return (
        <button
          type="submit"
          className="btn btn-block btn-primary"
          disabled={this.state.loginProgress}
        >
          Submit
        </button>
      );
    }
  };

  render() {
    return (
      <div className="wrap">
        <center>
          <h1 style={{ marginBottom: "-20px" }}>BCS</h1>
          <h2>Welcome to BCS</h2>

          <div
            style={{
              minHeight: "30px"
            }}
          ></div>

          <div
            style={{
              minHeight: "30px"
            }}
          ></div>
        </center>
        <div>
          <form onSubmit={this.loginHandler}>
            {window.location.hostname === this.state.localhost && (
              <div className="form-group">
                <label>Email address:</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  ref="email"
                  value={localState.login}
                  //value="test@test.com"
                  disabled={this.state.loginProgress}
                />
              </div>
            )}
            {window.location.hostname !== this.state.localhost && (
              <div className="form-group">
                <label>Email address:</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  ref="email"
                  //value="test@test.com"
                  disabled={this.state.loginProgress}
                />
              </div>
            )}
            {window.location.hostname === this.state.localhost && (
              <div className="form-group">
                <label>Password:</label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  secure
                  ref="password"
                  value={localState.password}
                  disabled={this.state.loginProgress}
                />
              </div>
            )}
            {window.location.hostname !== this.state.localhost && (
              <div className="form-group">
                <label>Password:</label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  secure
                  ref="password"
                  disabled={this.state.loginProgress}
                />
              </div>
            )}

            {this.getError()}

            {this.getLoader()}
          </form>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addRecord: data => dispatch(actionAddSingleRecord(data)),
    onSetUiFlag: (flagName, flagValue) =>
      dispatch(setUiFlag(flagName, flagValue)),
    onAddArray: data => dispatch(actionAddArray2Redux(data)),
    setupUsers: (email, firebase, teamValue, fbCloudUrl, fbDbUrl) =>
      dispatch(setupUsers(email, firebase, teamValue, fbCloudUrl, fbDbUrl)),
    loadFbData: (tableName, firebase) =>
      dispatch(loadFbData(tableName, firebase)),
    onSignOut: () => dispatch(resetRedux())
  };
};

function mapStateToProps(state) {
  return {
    currentUser: state.db.currentUser,
    menuDesigner: state.db.menuDesigner,
    listOfTables: state.db.listOfTables
  };
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirebase
)(UserLogin);



// WEBPACK FOOTER //
// ./src/app/components/Screens/Login/login.jsx